export default "__VITE_ASSET__ba958c2f__"